import { render, staticRenderFns } from "./Eixo.vue?vue&type=template&id=7dc94325&lang=true"
import script from "./Eixo.vue?vue&type=script&lang=js"
export * from "./Eixo.vue?vue&type=script&lang=js"
import style0 from "./Eixo.vue?vue&type=style&index=0&id=7dc94325&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports